<lib-calendar-appointment-chat-box
  [mode]="mode"
  [businessObject]="businessObject"
  [(appointment)]="appointment"
  [displayCloseButton]="true"
  [disable]="isEditActionForbiddenForStaffApp()"
  (closeClicked)="closeDialog()"
></lib-calendar-appointment-chat-box>
